export const LOG = {
    logs: [],
    MAX_LOGS: 100, // Limite di sicurezza per la memoria

    // Funzione principale per registrare un evento
    add(tipo, messaggio, dettagli = null) {
        const timestamp = new Date().toISOString();
        
        const nuovoLog = {
            timestamp,
            tipo: tipo.toUpperCase(), // 'INFO', 'ERROR', 'BACKEND'
            messaggio,
            dettagli: dettagli ? (typeof dettagli === 'object' ? JSON.stringify(dettagli) : dettagli) : null
        };

        // Inserisce in testa così il più recente è il primo dell'array
        this.logs.unshift(nuovoLog);

        // Se supera il limite, elimina il più vecchio
        if (this.logs.length > this.MAX_LOGS) {
            this.logs.pop();
        }

        // Opzionale: stampa comunque in console nativa così non perdi il comportamento standard
        if (tipo.toLowerCase() === 'error') {
            console.error(`[${timestamp}] ${messaggio}`, dettagli || '');
        } else {
            console.log(`[${timestamp}] ${messaggio}`, dettagli || '');
        }
    },

    // Esporta tutti i log in un unico blocco di testo leggibile
    ottieniFormatoTesto() {
        if (this.logs.length === 0) return "Nessun log registrato.";

        return this.logs.map(log => {
            let riga = `[${log.timestamp}] [${log.tipo}] ${log.messaggio}`;
            if (log.dettagli) {
                riga += `\n   Dettagli: ${log.dettagli}`;
            }
            return riga;
        }).join('\n\n');
    },

    // Svuota la memoria
    pulisci() {
        this.logs = [];
    }
};